module.exports = __webpack_public_path__ + "static/media/banner-placeholder.f30bb721.svg";